import { Component, OnInit, Inject, Input } from '@angular/core';
import * as moment from 'moment';
import { Router, NavigationStart } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BaseComponent } from '@app/base/base.component';
import { CredentialsService } from '@app/core/authentication/credentials.service';
import { ENVIRONMENT } from '@app/core/services/environment.service';
import { filter, map } from 'rxjs/operators';
import { ContentEditorService } from '@app/shared/services/content-editor.service';
import { Culture } from '@app/shared/models/content-editor.model';
import { ThemeService } from '@app/shared/services/theme.service';
import { MenuMappingConstants } from '@app/shared/constants/menu-mapping.constants';
import { KycProcessFlowService } from '@app/shared/services/kyc-process-flow.service';
import { CommonService } from '@app/shared/services/common.service';
import { UserLoginService } from '@app/services/auth/user-login.service';
@Component({
    selector: 'app-header',
    templateUrl: './original-header.component.html',
    styleUrls: ['./original-header.component.scss'],
})
export class OriginalHeaderComponent extends BaseComponent implements OnInit {
    public routerLogin = '/login/user';
    public routerHome = '/home';
    public routerMyCards = '/my-cards';
    public authenticated: boolean;
    public isAnonymousCardholder: boolean;
    public isRegisteredEndUser: boolean;
    public hideCardRelatedLinks = true;
    public showLoginExpirationTimer: boolean;
    public flagPath: string;
    isCollapsed = true;
    public isInactive: boolean;
    public displayName: string;
    public homeLinkLabel: string;
    public logoDefault: string;
    public menuMapping: any;
    @Input() public pcnOnly = false;
    isVerifiedUser: boolean;

    public loginExpiration$ = this.credentials.expiration.pipe(
        filter((seconds) => !!seconds),
        map((seconds) => moment().startOf('day').seconds(seconds).format('HH:mm:ss')),
    );
    getHeaderImageLink: string;

    constructor(
        private router: Router,
        private credentials: CredentialsService,
        private themeService: ThemeService,
        private kycProcessFlowService: KycProcessFlowService,
        public commonService: CommonService,
        private userLoginService: UserLoginService,
        private deviceDetector: DeviceDetectorService, 
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
        @Inject(ENVIRONMENT) private environment: any,
    ) {
        super();
    }

    ngOnInit(): void {
        const tenantName = this.themeService.themeConfig['non-css-properties']['site-title']['header'];
        this.homeLinkLabel = tenantName;
        this.logoDefault = tenantName ? '' : 'Default';
        this.hideCardRelatedLinks = this.router.url !== this.routerHome && this.router.url !== this.routerMyCards;
        this.getHeaderImageLink = this.themeService.themeConfig && this.themeService.themeConfig['header-logo-url'];
        this.subscriptions = [
            this.credentials.asObservable().subscribe((credentials) => {
                this.authenticated = !!credentials;
                if (!!credentials) {
                    this.isAnonymousCardholder = credentials.isAnonymousCardholder();
                    this.isRegisteredEndUser = credentials.isRegisteredEndUser();
                    this.displayName = credentials.displayName;
                } else {
                    this.isAnonymousCardholder = false;
                    this.isRegisteredEndUser = false;
                }
                this.isVerifiedUser = credentials && (credentials.isRegisteredEndUser() || credentials.isAdmin()) ? true : false;
                this.filterMenu();
            }),
            // TODO This doesnt work as expected right now, header gets refreshed every time we navigate, revisit when we fix it.
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.hideCardRelatedLinks = event.url !== '/home' && event.url !== '/my-cards';
                }
            }),
        ];

        this.showLoginExpirationTimer = !!this.environment.showLoginExpirationTimer;
    }

    filterMenu(): MenuMappingConstants {
        if (this.pcnOnly && !this.isVerifiedUser) {
            this.menuMapping = MenuMappingConstants.MENU_DATA.filter((data) => data.pcnOnly === this.pcnOnly);
        } else {
            this.menuMapping = MenuMappingConstants.MENU_DATA.filter((data) => data.isAuthentication === this.isVerifiedUser);
        }
        return this.menuMapping;
    }

    get mobileDetected(): boolean { 
        return this.deviceDetector.isMobile();
    }
    get tabletDetected(): boolean {
        return this.deviceDetector.isTablet();
    }

    async logout(): Promise<void> {
        await this.userLoginService.logout();
        this.credentials.clear();
    }

    allowRedirection(menu) {
        if (menu === 'shell.header.signIn') {
            this.kycProcessFlowService.allowRedirectionforHeaderLogin = true;
        }
    }
}
